<template>
  <div class="bg">
    <div class="container">
      <img src="../assets/logo.png" class="logo" />
      <form
        class="box-container"
        @submit.prevent="submit"
        v-if="!$store.state.coach"
      >
        <p>Sign up for IMCLA Player Directory</p>
        <div class="switch-container">
          <button :class="{ active: !person }" @click="person = false">
            Player
          </button>
          <button :class="{ active: person }" @click="person = true">
            Coach
          </button>
        </div>
        <input type="text" placeholder="Name" v-model="fullname" />
        <input type="email" placeholder="Email" v-model="email" />
        <input type="password" placeholder="Password" v-model="password" />
        <input
          type="password"
          placeholder="Comfirm Password"
          v-model="repeatPassword"
        />
        <button type="submit">Free Sign up</button>
      </form>
      <button class="premium">Go Premium</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      person: true,
      fullname: true,
      email: "",
      password: "",
      repeatPassword: "",
    };
  },
  methods: {
    submit() {
      const credentials = {
        email: this.email,
        password: this.password,
      };
      this.$store.dispatch("login", credentials).catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bg {
  background: url("../assets/bg.png");
  background-size: cover;
  width: 100%;
}
.container {
  max-width: 747px;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 28px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.39);
}

img.logo {
  width: 100%;
}
.switch-container {
  display: block;
  text-align: center;
}
form.box-container {
  padding: 50px 30px 20px;
}

form.box-container p {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  color: #707070;
  font-size: 24px;
  text-align: center;
  padding-bottom: 30px;
}

form.box-container input {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  width: 100%;
  border: none;
  border-bottom: 1px solid #707070;
  padding: 10px 5px;
  margin-bottom: 30px;
  font-size: 24px;
  line-height: 28px;
  outline: none;
  color: #707070;
}

form.box-container button[type="submit"] {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  background: #707070;
  width: 226px;
  padding: 8px;
  color: #fff;
  border: none;
  font-size: 28px;
  display: block;
  margin: 0 auto;
  cursor: pointer;
  border-radius: 5px;
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.5);
}

form.box-container .forgot-link {
  color: #0063ae;
  text-align: center;
  display: block;
  text-decoration: none;
  padding-top: 20px;
  font-size: 21px;
}

button.premium {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  background: #005fa8;
  width: 226px;
  padding: 8px;
  color: #fff;
  border: none;
  font-size: 28px;
  display: block;
  margin: 0 auto;
  cursor: pointer;
  border-radius: 5px;
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.5);
}
</style>
